import { render } from "./detail-ir.vue?vue&type=template&id=8c279922"
import script from "./detail-ir.vue?vue&type=script&lang=js"
export * from "./detail-ir.vue?vue&type=script&lang=js"

import "./detail-ir.vue?vue&type=style&index=0&id=8c279922&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__